import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Popup, Icon, Menu } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import OrganizerFileIcon from "./OrganizerFileIcon";

/**
 * OrganizerFileItem: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Represents a file in the Organizer view.
 *
 * @param {*} props
 */

class OrganizerFileItem extends Component {
  state = {
    isMenuOpen: false
  };

  setIsMenuOpen = isOpen => {
    this.setState({
      isMenuOpen: isOpen
    });
  };

  render() {
    return (
      <div className="or-file-object">
        <Button className="or-file-item" onClick={this.props.onSelect}>
          <OrganizerFileIcon documentType={this.props.type} size={24} />
          <div className="or-file-name">
            <span title={this.props.filename}>{this.props.filename}</span>
          </div>
        </Button>
        <Popup
          basic
          style={{ boxShadow: "none", padding: "0", border: "none" }}
          on="click"
          position="right center"
          open={this.state.isMenuOpen}
          onOpen={() => this.setIsMenuOpen(true)}
          onClose={() => this.setIsMenuOpen(false)}
          trigger={
            <Button className="or-file-more" icon="ellipsis vertical" compact />
          }
          content={
            <Menu vertical fluid className="or-action-menu">
              {/**
               * Opens the file
               */}
              <Menu.Item name="open" onClick={this.props.onSelect}>
                <Icon name="folder open" />
                <span>
                  <FormattedMessage
                    id="organizer.menu.open"
                    description="Action text to open a file"
                  />
                </span>
              </Menu.Item>
              {/**
               * Deletes the file from its context
               */}
              <Menu.Item
                name="delete"
                onClick={this.props.onDelete}
                className="destructive"
              >
                <Icon name="trash alternate" />
                <span>
                  <FormattedMessage
                    id="organizer.menu.delete"
                    description="Action text to delete a file"
                  />
                </span>
              </Menu.Item>
            </Menu>
          }
        />
      </div>
    );
  }
}

OrganizerFileItem.propTypes = {
  filename: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default OrganizerFileItem;



// WEBPACK FOOTER //
// ./src/modules/organizer/view/OrganizerFileItem.js